var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home ce-main-wrapper ce-sso-dash",class:{'ce-sso-dashno-nav': !_vm.isAdmin}},[_c('header-area',{on:{"toggleSidenav":_vm.toggleNav}}),_c('div',{staticClass:"ce-wrapper",class:{'ce-collapsed' : _vm.toggle}},[_c('side-nav'),_c('router-view')],1),_c('footer-area')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }